import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslocoService } from '@ngneat/transloco';

@Injectable()
export class CustomPaginatorIntl extends MatPaginatorIntl {

  constructor(private _translocoService: TranslocoService) {
    super();

    // Escucha los cambios de idioma para actualizar las etiquetas dinámicamente
    this._translocoService.langChanges$.subscribe(() => {
      this.getTranslations();
    });

    this.getTranslations();
  }

  getTranslations(): void {
    this.itemsPerPageLabel = this._translocoService.translate('itemsPerPage') || 'Elementos por página:';
    this.nextPageLabel = this._translocoService.translate('nextPage') || 'Página siguiente';
    this.previousPageLabel = this._translocoService.translate('previousPage') || 'Página anterior';
    this.firstPageLabel = this._translocoService.translate('firstPage') || 'Primera página';
    this.lastPageLabel = this._translocoService.translate('lastPage') || 'Última página';

    // Notifica a Angular Material para que vuelva a renderizar los tooltips/labels
    this.changes.next();
  }

  // Traducción del rango "1 – 10 de 50"
  override getRangeLabel = (page: number, pageSize: number, length: number): string => {
    if (length === 0 || pageSize === 0) {
      return `0 ${this._translocoService.translate('of') || 'de'} ${length}`;
    }
    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
    return `${startIndex + 1} – ${endIndex} ${this._translocoService.translate('of') || 'de'} ${length}`;
  };
}